import { useEffect } from 'react';
var subscribers = new Map();
function subscribe(type, callback) {
    if (type === undefined || type === null)
        return;
    if (callback === undefined || callback === null)
        return;
    if (!subscribers.has(type))
        subscribers.set(type, new Set());
    subscribers.get(type).add(callback);
}
function unsubscribe(type, callback) {
    if (!subscribers.has(type))
        return;
    if (callback === undefined || callback === null)
        return;
    subscribers.get(type).delete(callback);
    if (subscribers.get(type).size === 0)
        subscribers.delete(type);
}
function isAction(actionOrType) {
    return typeof actionOrType !== 'string';
}
function dispatch(actionOrType) {
    var action = isAction(actionOrType) ? actionOrType : { type: actionOrType };
    if (!subscribers.has(action.type))
        return;
    // if we use set without conversion to array
    // subscribers.get(type).forEach
    // it stucks if it has two same functions
    // tested on notification counter at home screen
    // It is not clear why it happens,
    // conversion to array did a trick
    // however it may only hide a real problem.
    var data = Array.from(subscribers.get(action.type));
    data.forEach(function (callback) {
        callback(action);
    });
}
function useBus(type, callback, deps) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
        subscribe(type, callback);
        return function () {
            unsubscribe(type, callback);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return dispatch;
}
export function createBus() {
    var useBusTyped = useBus;
    var dispatchTyped = dispatch;
    return {
        useBus: useBusTyped,
        dispatch: dispatchTyped,
    };
}
// Example of usage
// interface Inc {
//     type: 'inc';
// }
// interface Dec {
//     type: 'dec';
//     value: number;
// }
// type Event = Inc | Dec;
// const b = createBus<Event>();
// // ok
// b.dispatch({ type: 'inc' });
// b.dispatch('inc');
// b.dispatch({ type: 'dec', value: 1 });
// b.useBus('inc', () => {}, []);
// b.useBus('dec', () => {}, []);
// // error
// b.dispatch({ type: 'dec' });
// b.dispatch('dec');
// b.dispatch({ type: 'foo' });
// b.useBus('__super_error__', () => {}, []);
//# sourceMappingURL=bus.js.map